//import 'bootstrap';
// Import just what we need

// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
import zoomInit from "./frontend/zoomInit";
import headerSocket from "./frontend/headerSocket";
import loadMoreJobs from "./frontend/load-more-jobs";

import smoothscroll from 'smoothscroll-polyfill';
import headerAnimation from "./frontend/header-parallax";
import initCarousel from "./frontend/carousel";
import benefitSlider from "./frontend/benefitSlider";
import showHiddenCardPart from "./frontend/plusToX";
import scrollDownButton from "./frontend/scrollDownButton";
import playVideoThenShowContent from "./frontend/playVideoThenShowContent";
import animateWorkLife from "./frontend/workLifeAnimation";
// import topicPeople from "./frontend/topicsPeople";
import topicPeopleOverlay from "./frontend/topicsPeopleOverlay";
import toggleFilterOnMobile from "./frontend/toggleFilterOnMobile";
import toggleFloatingContact from "./frontend/toggleFloatingContact";
import setFilterButtons from "./frontend/setFilterButtons";
import openPositionFloatyDisappear from "./frontend/openPositionsFloatyDisappear";
import headerScroll from "./frontend/headerScroll";
import initClipboard from "./frontend/copy-to-clipboard";
import headerSocketSlider from "./frontend/headerSocketSlider";
import initializeTiles from "./frontend/tiles";
import menuBuilder from "./frontend/menuBuilder";
import lazyInit from './frontend/lazyimages';
import jobFilter from './frontend/job-filter';
import videoModalButton from './frontend/video-modal-button';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load" // notice "resize" isn't in the list
});

import {applyHyphenation} from "./frontend/hyphen";

const killAllScrollTriggers = () => {
    let allScrollTriggers = ScrollTrigger.getAll();
    if(allScrollTriggers.length > 0){
        allScrollTriggers.forEach(trigger =>{
            trigger.kill();
        })
    }
}

function setDocHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
};



setDocHeight();
document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
        smoothscroll.polyfill();
        toggleFloatingContact();
        showHiddenCardPart();
        setFilterButtons();
        scrollDownButton();
        initCarousel();
        animateWorkLife();
        toggleFilterOnMobile();
        killAllScrollTriggers();
        headerScroll();
        zoomInit();
        headerAnimation();
        //playVideoThenShowContent();
        // topicPeople();
        topicPeopleOverlay();
        benefitSlider();
        openPositionFloatyDisappear();
        initClipboard();
        headerSocket();
        headerSocketSlider();
        initializeTiles();
        menuBuilder();
        lazyInit();
        loadMoreJobs();
        jobFilter();
        loadMoreJobs();
        videoModalButton();
        applyHyphenation();
    }
}
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    killAllScrollTriggers();
    setFilterButtons();
    initCarousel();
    animateWorkLife();
    toggleFilterOnMobile();

    setDocHeight();
    headerScroll();
    zoomInit();
    headerAnimation();
    //playVideoThenShowContent();
    // topicPeople();
    benefitSlider();
    openPositionFloatyDisappear();
    headerSocket();
    headerSocketSlider();
    menuBuilder();
    currentWidth = window.innerWidth;

}, false)
// window.addEventListener('scroll', () =>{console.log('scrolled')})

/*
if(typeof screen.orientation !== 'undefined'){
    screen.orientation.addEventListener('change', function() {
        initCarousel();
        benefitSlider();


    })
}else{
    window.addEventListener("orientationchange", function() {
        initCarousel();
        benefitSlider();
    }, false);
}
*/
